var QawafilStoreFrontCustomer = (function () {
    'use strict';


    function registerAddressesEvents() {

        var refreshAddresses = function (){
            QawafilStoreFront.helpers.blockPage();
            $.ajax({
                url: '/account/addresses',
                method: 'GET',
                success: function (response) {
                    const $response = $(response); // Wrap the response in a jQuery obj

                    // Find the cart_items_container in the response
                    const addressesHTML = $response.find('#addresses-container').html();
                    // Append the extracted HTML to mini_cart_container
                    $('#addresses-container').html(addressesHTML);
                },
                error: function (error) {
                    console.log('Error:', error);
                },
                complete: function (){
                    QawafilStoreFront.helpers.unBlockPage();
                }
            });
        }

        var modalMapShown = false;

        if ($('#address-location-picker-map').length > 0) {
            try {
                $('#address-location-picker-map').locationpicker({
                    location: {
                        latitude: 24.70903825791268,
                        longitude: 46.67867760121877
                    },
                    radius: 2,
                    zoom: 7,
                    //mapTypeId: google.maps.MapTypeId.HYBRID,
                    inputBinding: {
                        latitudeInput: $('#save_address_form #lat'),
                        longitudeInput: $('#save_address_form #lng'),
                        radiusInput: $('#lp-radius'),
                        locationNameInput: $('#save_address_form #lp-address')
                    },
                    enableAutocomplete: true,
                    draggable: true,
                    markerInCenter: true,
                    onchanged: function (currentLocation, radius, isMarkerDropped) {
                        try {
                            var address = $(this).locationpicker('map').location.addressComponents;
                            //$('#lp-address').val(address.country + ', ' + address.city + ', ' + address.district + ' , ' + address.addressLine1 +  ', ' + address.postalCode);
                            console.log(currentLocation, address);

                            $.ajax({
                                type: 'POST',
                                url: Qawafil.getShopUrl() + '/cities/get/data',
                                data: {
                                    'country_code': address.country.toLowerCase(),
                                    'latitude': currentLocation.latitude,
                                    'longitude': currentLocation.longitude,
                                    'cities':
                                        {
                                            '0': {
                                                'long_name': address.city ?? 'undefined',
                                                'short_name': address.city ?? 'undefined',
                                            },
                                            '1': {
                                                'long_name': address.district ?? 'undefined',
                                                'short_name': address.district ?? 'undefined',
                                            },
                                        },
                                },
                                success: function (response) {
                                    if (response.status) {
                                        $('#save_address_form #country_id').val(response.data.country_id);
                                        $('#save_address_form #country_id').attr('data-selected-city', response.data.city.id); // save the city id to make it selected after refreshing country cities
                                        $('#save_address_form #country_id').trigger('change');

                                        if (response.data.place_details != null) {
                                            let place_details = response.data.place_details;

                                            if (place_details.district !== null) {
                                                $('#save_address_form #district').val(place_details.district.long_name);
                                            }

                                            if (place_details.postal_code !== null) {
                                                $('#save_address_form #zip').val(place_details.postal_code.long_name);
                                            }

                                            if (place_details.street !== null) {
                                                $('#save_address_form #street').val(place_details.street.long_name);
                                            }
                                        }

                                    } else {
                                        toastWarning(response.message);
                                    }
                                }

                            });

                            //$('#save_address_form #district').val(address.district);
                            //$('#save_address_form #zip').val(address.postalCode);
                            $('#save_address_form #details').val(address.addressLine1);
                        } catch (error) {
                            // console.log('Error getting address from map')
                            console.log('Error getting address from map',error)
                        }

                    }
                });
            }catch (error){}
        }

        $('#save_address_modal').on('shown.bs.modal', function () {
            if (!modalMapShown) {
                $('#address-location-picker-map').locationpicker('autosize');
                modalMapShown = true;
            }
        });

        $(document).on('click', '#add_new_address_btn', function () {
            $('#save_address_modal #address_id').val(null);
        });

        $('#save_address_form').submit(function (e) {
            e.preventDefault();
            var addressFormDetails = {};
            $.each($('#save_address_form').serializeArray(), function (_, kv) {
                addressFormDetails[kv.name] = kv.value;
            });
            // Get callback name from button data attribute
            let callbackName = $('#add_new_address_btn').data('customCallback');
            // Convert to actual function reference if exists in window
            let customCallback = typeof window[callbackName] === 'function' ? window[callbackName] : null;
            Qawafil.customer.address.saveAddress(addressFormDetails, addressFormDetails.address_id,
                customCallback || function (response) {
                        if (response) {
                            if (response.status) {
                                $('#empty-wrapper').hide();
                                $('#save_address_modal').modal('hide');
                                if (response.message) toastSuccess(response.message);
                                refreshAddresses();

                            } else {
                                if (response.message && response.code !== 403) toastError(response.message);
                            }
                        } else {
                            toastError();
                        }
            });
        });

        $(document).on('click', '.btn-edit-address', function () {
            let addressId = $(this).attr('data-address-id');
            Qawafil.customer.address.getAddress(addressId, function (response) {
                if (response) {
                    if (response.status) {
                        let address = response.data;
                        $('#save_address_form #address_id').val(address.id);
                        $('#save_address_form #country_id').val(address.country.id);
                        $('#save_address_form #country_id').attr('data-selected-city', address.city.id); // save the city id to make it selected after refreshing country cities
                        $('#save_address_form #country_id').trigger('change');
                        $('#save_address_form #street').val(address.street);
                        $('#save_address_form #district').val(address.district);
                        $('#save_address_form #zip').val(address.postal_code);
                        $('#save_address_form #details').val(address.details);

                        $('#save_address_modal').modal('show');

                        $('#address-location-picker-map').locationpicker({
                            location: {
                                latitude: address.latitude ?? 24.70903825791268,
                                longitude: address.longitude ?? 46.67867760121877
                            },
                            zoom: 13,
                        });


                    } else {
                        if (response.message && response.code !== 403) toastError(response.message)
                    }
                } else {
                    toastError();
                }
            });
        });

        $(document).on('click', '.set_default_address', function () {
            let addressId = $(this).attr('data-address-id');
            Qawafil.customer.address.setAsDefault(addressId, function (response) {
                if (response) {
                    if (response.status) {
                        if (response.message) toastSuccess(response.message)
                    } else {
                        if (response.message && response.code !== 403) toastError(response.message)
                    }
                } else {
                    toastError();
                }
            });
        });

        $(document).on('click', '.btn-delete-address', function () {
            let addressId = $(this).attr('data-address-id');
            Qawafil.customer.address.deleteAddress(addressId, function (response) {
                if (response) {
                    if (response.status) {
                        $(`#address_${addressId}`).remove();
                        if (response.message) toastSuccess(response.message)
                    } else {
                        if (response.message && response.code !== 403) toastError(response.message)
                    }
                } else {
                    toastError();
                }

            });
        });


    }

    /**
     * WS-WCA D5: the WhatsApp switches of the account page (ShopAPI user/whatsapp-consent). Each change saves at once;
     * the answer brings the switches as the server has them (a refused "on" goes back to off).
     */
    function showWhatsappSwitches(switches) {
        let card = $('#whatsapp_consent_card');
        let any = false;
        $.each(switches || {}, function (kind, parts) {
            let row = card.find('.whatsapp-consent-switch[data-kind="' + kind + '"]');
            row.toggleClass('d-none', !parts.show_switch);
            row.find('input[type="checkbox"]').prop('checked', !!parts.switch_on);
            any = any || parts.show_switch;
        });
        card.toggleClass('d-none', !any);
    }

    function sendWhatsappConsent(method, body, done) {
        if (!$('#whatsapp_consent_card').length) {
            return;
        }
        let settings = {
            url: Qawafil.APIHelpers.getShopAPIEndpoint() + '/user/whatsapp-consent',
            requestOptions: {method: method},
            callback: function (response) {
                if (response && response.data && response.data.switches) {
                    showWhatsappSwitches(response.data.switches);
                }
                if (typeof done === 'function') done(response);
            }
        };
        if (body) settings.requestOptions.body = Qawafil.APIHelpers.jsonBody(body);
        Qawafil.APIHelpers.sendApiRequest(settings);
    }

    function registerCustomerAccountEvents(){

        $('#whatsapp_consent_card').on('change', 'input[type="checkbox"]', function () {
            let box = $(this);
            box.prop('disabled', true);
            sendWhatsappConsent('POST', {kind: box.data('kind'), on: box.is(':checked') ? 1 : 0}, function (response) {
                box.prop('disabled', false);
                if (!response) {
                    box.prop('checked', !box.is(':checked'));
                    toastError();
                } else if (response.message) {
                    response.status ? toastSuccess(response.message) : toastError(response.message);
                }
            });
        });

        let profileForm = $("#profile_form");

        profileForm.on('submit', function(e) {
            e.preventDefault();
            let formData = new FormData($(this)[0]);
            Qawafil.customer.account.updateProfile(formData, function(response){
                if (response) {
                    if (response.status) {
                        if (response.message) toastSuccess(response.message)
                        // WS-WCA D5: a new number changes the WhatsApp switches (a "yes" counts only for its own number).
                        sendWhatsappConsent('GET', null);
                    } else {
                        if (response.message && response.code !== 403) toastError(response.message)
                    }
                } else {
                    toastError();
                }
            });
        });
    }

    function registerCustomerWishlistEvents() {
        $(document).on('click', '.remove-wishlist-btn', function (){
            let prdId = $(this).attr('data-prd-id');
            let button = $(this);
            Qawafil.customer.wishlist.toggleWishlist(prdId, function (response){
                if(response && response.status){
                    button.closest('.prd').remove();
                    if(response.message) toastSuccess(response.message)
                }
            });
        });

        $(document).on('click', '.toggle-wishlist-btn', function (){
            let prdId = $(this).attr('data-prd-id');
            let button = this;
            Qawafil.customer.wishlist.toggleWishlist(prdId, function (response){
                if (response && response.status && response.data) {
                    if(response.message) toastSuccess(response.message)
                    switch (response.data.result) {
                        case 'added':
                            button.classList.add('active');
                            if (button.children[0]) {
                                button.children[0].classList.remove('far');
                                button.children[0].classList.add('fas');
                            }
                            break;
                        case 'removed':
                            button.classList.remove('active');
                            if (button.children[0]) {
                                button.children[0].classList.remove('fas');
                                button.children[0].classList.add('far');
                            }
                            break;
                    }
                }

            });
        });
    }

    function registerCustomerNotificationsEvents(){

        var getNotificationsHtml = function (notifications) {

            console.log('getNotificationsHtml:notifications', notifications);
            let count = notifications.length;
            let result = ``;
            notifications.forEach(function (noti_row) {
                try {
                    result += `
            <div class="i7-noti-prd i7-noti-item ${noti_row.is_read ? '' : 'i7-noti-read'}">
                <div class="i7-noti-prd-name row">
                    <div class="col-2 px-0 justify-content-center align-self-center">
                        <i class="far fa-bell fa-2x text-brand"></i>
                    </div>
                    <div class="col-10 ">

                        <h3 class="${Qawafil.isRtl() ? 'text-right' : 'text-left'}">
                            <a href="${noti_row.store_front_link}">
                                ${noti_row.title}
                            </a>
                        </h3>
                        <p class="${Qawafil.isRtl() ? 'text-right' : 'text-left'}">
                            ${noti_row.body}
                        </p>
                        <p class="${Qawafil.isRtl() ? 'text-left' : 'text-right'} w-100 px-1 text-brand">
                            ${noti_row.created_at}
                        </p>
                    </div>

                </div>
            </div>

        `;
                }catch (error){
                }

            });


            if (count === 0) {
                result += `<div class="cart-empty mx-auto i7-empty-noti">
                            <div class="cart-empty-icon"><i class="far fa-bell-slash"></i></div>
                            <div class="cart-empty-text">
                                <h3 class="cart-empty-title"> لا يوجد إشعارات</h3>
                            </div>
                        </div>`;
            }
            return result;
        }

        $('#header_notifications_btn').on('click', function () {

            var notifications_user_id = $("#notifications_user_id").val();
            let IsDropdownOpened = $(this).closest('.dropdn').hasClass('opened');
            consoleLog('IsDropdownOpened:before',IsDropdownOpened)
            $(this).closest('.dropdn').toggleClass('opened')
            consoleLog('IsDropdownOpened:after',IsDropdownOpened)
            if (notifications_user_id && !IsDropdownOpened) {
                $('#header_notifications_btn').attr('disabled', true)
                Qawafil.customer.notitications.getLastNotifications(function (response) {
                    if (response && response.status) {
                        console.log('getLastNotifications')
                        $('#header_notifications_btn').attr('disabled', false)
                        $('.header_notifications_home').html(getNotificationsHtml(response.data.notifications));
                        $('#header_notifications_count_home').text(0);
                    }
                })
            }

        });

        $(document).on('click', '.clearNotification', function () {
            var notifications_user_id = $("#notifications_user_id").val();
            // $(".notification-list").html('');
            if (notifications_user_id) {
                Qawafil.customer.notitications.deleteAllNotifications(function (response) {
                    if (response && response.status) {
                        $('#empty_notifications').show();
                        $('.notification-list').hide();
                        if(response.message) toastSuccess(response.message)
                    }
                })
            }

        });
    }

    function registerCustomerSettingsEvents() {
        $(document).on('click', '.switch-locale', function (){
            let locale = $(this).attr('data-locale');
            Qawafil.customer.settings.changeLocale(locale, function (response){
                if(response && response.status){
                    Qawafil.localization.setLocale(locale);
                    window.location.reload();
                    if(response.message) toastSuccess(response.message)
                }

            });
        });

    }

    function init() {
        registerAddressesEvents();
        registerCustomerAccountEvents();
        registerCustomerWishlistEvents();
        registerCustomerNotificationsEvents();
        registerCustomerSettingsEvents();
    }

    return {
        init: init
    };

})();
